<!-- 数据交易平台 -->
  <!-- 数据需求申请 -->
<template>
	<div :class="{ 'apply-page': !readOnly }">
    <div class="apply-hero" v-if="!readOnly">
      <h1>{{ applyTitle }}</h1>
      <p>填写交易所资料，并挂到运营主体企业。企业可以现场填写，也可以从企业库选择。提交后进入审核，预计 1–3 个工作日。</p>
    </div>
		<EnterpriseBind v-if="!readOnly" ref="enterpriseBind" />
				<el-form
				v-loading="loading"
				:class="{ 'apply-card': !readOnly }"
				:model="ruleForm"
				label-width="150px"
				:rules="rules"
				ref="ruleFormRef"
				>
				<div>
					<TitleTool title="数据交易所基本信息"/>
					<div class="pr10 pl10">
						<el-row v-if="readOnly && enterpriseName">
							<el-col :span="12">
								<el-form-item label="运营企业:">
									<span>{{ enterpriseName }}</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item
									label="数据交易所全称:"
									prop="dataTradingFull"
									:rules="readOnly ? [{required: false }] : rules.dataTradingFull"
								>
									<span v-if="readOnly">
										{{ ruleForm.dataTradingFull }}
									</span>
									<el-input
										v-else
										placeholder="请输入"
										v-model="ruleForm.dataTradingFull"
										maxlength="100"
										show-word-limit
										clearable
									/>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item
									label="数据交易所官网:"
									prop="dataTradingWeb"
								>
								<span v-if="readOnly">
									{{ ruleForm.dataTradingWeb }}
								</span>
								<el-input
									v-else
									placeholder="请输入"
									v-model="ruleForm.dataTradingWeb"
									maxlength="100"
									show-word-limit
									clearable
								/>
								</el-form-item>
								</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item
									label="数据交易所简称:"
									prop="dataTradingShort"
								>
									<span v-if="readOnly">
										{{ ruleForm.dataTradingShort }}
									</span>
									<el-input
										v-else
										placeholder="请输入"
										v-model="ruleForm.dataTradingShort"
										maxlength="10"
										show-word-limit
										clearable
									/>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item
									label="电话:"
									prop="phone"
									:rules="readOnly ? [{required: false }] : rules.phone"
								>
									<span v-if="readOnly">
										{{ ruleForm.phone }}
									</span>
									<el-input
										v-else
										placeholder="请输入"
										v-model="ruleForm.phone"
										clearable
									/>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item
									label="成立日期:"
									prop="setUpDate"
								>
									<span v-if="readOnly">
										{{ ruleForm.setUpDate }}
									</span>
									<GsDate v-else v-model="ruleForm.setUpDate" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item
									label="邮箱:"
									prop="email"
								>
								<span v-if="readOnly">
									{{ ruleForm.email }}
								</span>
									<el-input
										v-else
										placeholder="请输入"
										v-model="ruleForm.email"
										clearable
									/>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item
									label="办公地址:"
									prop="officeAddress"
								>
									<span v-if="readOnly">
										{{ ruleForm.officeAddress }}
									</span>
									<GsRegionAddress
										v-else
										v-model="ruleForm.officeAddress"
									/>
								</el-form-item>
								</el-col>
							<el-col :span="12">
								<el-form-item
									label="行政区划:"
									prop="administrativeDivisionCode"
								>
								<span v-if="readOnly">
									{{ ruleForm.administrativeDivisionName }}
								</span>
									<GsRegionSelect
										v-else
										v-model="ruleForm.administrativeDivisionCode"
										placeholder="请选择数据服务区域"
									/>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
								<el-col>
								<el-form-item
									label="交易所介绍"
									prop="tradingCenterIntroduction"
								>
									<span v-if="readOnly">
										{{ ruleForm.tradingCenterIntroduction }}
									</span>
									<el-input
										v-else
										type="textarea"
										placeholder="请输入您数据需求内容，文字不要超过1500字"
										v-model="ruleForm.tradingCenterIntroduction"
										maxlength="1500"
										show-word-limit
										:autosize="{ minRows: 3}"
									/>
								</el-form-item>
							</el-col>
						</el-row>
					</div>
				</div>
			</el-form>
			<div class="apply-actions" v-if="!readOnly">
				<el-button @click="close">取消</el-button>
				<el-button type="primary" @click="save">提交申请</el-button>
			</div>
		<!-- <FooterData v-if="!readOnly" /> -->
	</div>
</template>
<script>
import { dataTradingInfo, dataTradingDetail, enterpriseInfoDetail } from '@/api/Home/index.js'
import ValidateReg from '@/utils/validateReg.js'
import GsRegionSelect from '@/components/GsRegionSelect/index.vue'
import GsRegionAddress from '@/components/GsRegionAddress/index.vue'
import EnterpriseBind from '@/components/EnterpriseBind/index.vue'
import { gsConfirm } from '@/utils/gsConfirm'
import '@/views/Layout/components/Header/components/apply-form.css'
export default {
name: 'DataTradingInfo',
components: { GsRegionSelect, EnterpriseBind, GsRegionAddress },
props: {
	readOnly:{
		type: Boolean,
		default: false
	},
	dialogTitle: {
		type: String,
		default: ''
	},
	tradingId: {
		type: Number,
		default: 0
	}
},
data() {
  const validatePhone = (rule, value, callback) => {
    if (!value) {
      return callback(new Error('请输入电话'));
    }
    
    const mobilePattern = /^1[3-9]\d{9}$/;
    const telPattern = /^(\(\d{3,4}\)|\d{3,4}-?)?\d{7,8}$/;
    
    if (mobilePattern.test(value) || telPattern.test(value)) {
      callback();
    } else {
      callback(new Error('请输入正确的手机号或座机号'));
    }
  }
	return {
		loading: false,
		title: (this.$route.meta && this.$route.meta.title) || '',
		applyTitle: (this.$route.meta && this.$route.meta.title) || '数据交易所申请',
		areaList: [],
		rules:{
			dataTradingFull: [
				{ required: true, message: '请输入数据交易所全称', trigger: ['blur', 'change'] }
			],
			email :[
				{ required: false, message: '请输入邮箱', trigger: ['blur', 'change'] },
				{ pattern: ValidateReg.emailReg, message: '邮箱格式不正确', trigger: ['blur', 'change']}
			],
			phone: [
        { required: true, message: '请输入电话', trigger: ['blur', 'change'] },
        { validator: validatePhone, trigger: ['blur', 'change'] }
      ]
		},
		ruleForm: {
			dataTradingFull: ''
		},
		enterpriseName: '',
		industryEnum: null
	}
},
watch: {
	tradingId:{
		immediate:true,
		handler(val) {
			if(val && this.readOnly) {
				this.initDetail(val)
			}
		}
	}
},
methods: {
	initDetail(id) {
		this.loading = true
		dataTradingDetail(id).then(res=>{
			this.loading = false
			this.ruleForm = res.data || {}
			if (this.ruleForm.enterpriseId) {
				enterpriseInfoDetail(this.ruleForm.enterpriseId).then((ent) => {
					this.enterpriseName = (ent && ent.data && ent.data.enterpriseName) || ''
				}).catch(() => {})
			}
		}).catch(()=>{
			this.loading = false
		})
	},
	save() {
	const code = this.ruleForm.administrativeDivisionCode
	if (code && typeof code !== 'string') {
		this.ruleForm.administrativeDivisionCode = JSON.stringify(code)
	}
	this.$refs.ruleFormRef.validate((valid) => {
		if (!valid) return
		const bind = this.$refs.enterpriseBind
		if (!bind) return
		bind.validate().then((ok) => {
			if (!ok) {
				this.$message.error('请选择企业，或填写新企业')
				return
			}
			gsConfirm({
				message: '确定提交申请吗？提交后进入审核。',
				confirmButtonText: '提交',
				cancelButtonText: '再看看'
			}).then(() => {
				this.loading = true
				bind.resolveId().then((enterpriseId) => {
					this.ruleForm.enterpriseId = enterpriseId
					return dataTradingInfo(this.ruleForm)
				}).then((res) => {
					this.loading = false
					if (res && res.code === 200) {
						this.$router.go(-1)
						this.$alert('申请已提交，审核需要 1–3 个工作日，请保持电话畅通。', '提交成功', {
							confirmButtonText: '我知道了'
						})
					}
				}).catch(() => {
					this.loading = false
				})
			}).catch(() => {
				this.loading = false
			})
		})
	})
	},
	close() {
	  gsConfirm({
        message: '确定离开本页吗？未提交的内容不会保存。',
        confirmButtonText: '离开',
        cancelButtonText: '继续填写'
      }).then(() => {
		this.$router.go(-1)
	  }).catch(()=>{})
	}
}
}
</script>
<style lang="css" scoped>
	.search-content{
	padding: 20px;
	}
	.search-search {
	text-align: center;
	}
	::v-deep .form-label .el-form-item__content {
	display: flex !important;
	flex-wrap: wrap;
	}
</style>